// extracted by mini-css-extract-plugin
module.exports = {"button":"styles-module__button___2_N66"};